import { FrequencyCadenceTypeEnum, type RescheduledFrequency, type SearchFrequencyViewModel } from '@generated';
import { isEqual } from '~/util/date';

export function applyReschedules(frequencies: SearchFrequencyViewModel[], rescheduled: RescheduledFrequency[]): SearchFrequencyViewModel[] {
	return frequencies.map(x => {
		const change = rescheduled.find(y => y.frequencyId === x.id);
		return change ? { ...x, scheduledDateAndTime: change.scheduledDateAndTime } : x;
	});
}

export function upsertReschedule(rescheduled: RescheduledFrequency[], change: RescheduledFrequency): RescheduledFrequency[] {
	return rescheduled.some(x => x.frequencyId === change.frequencyId)
		? rescheduled.map(x => (x.frequencyId === change.frequencyId ? change : x))
		: [...rescheduled, change];
}

export function isRescheduled(frequency: SearchFrequencyViewModel, change: RescheduledFrequency): boolean {
	return !isEqual(frequency.scheduledDateAndTime, change.scheduledDateAndTime);
}

export function canChangeDate(frequencyCadenceTypeId: number): boolean {
	return frequencyCadenceTypeId === FrequencyCadenceTypeEnum.Weekly || frequencyCadenceTypeId === FrequencyCadenceTypeEnum.Monthly;
}

export function getCadenceConstraintMessage(frequencyCadenceTypeId: number): string {
	switch (frequencyCadenceTypeId) {
		case FrequencyCadenceTypeEnum.Weekly:
			return 'Weekly frequencies must stay within the same Medicare week';
		case FrequencyCadenceTypeEnum.Monthly:
			return 'Monthly frequencies must stay within the same calendar month';
		default:
			return 'Only the time can be changed for this frequency';
	}
}
